import { useState } from "react";
import { Box, Button, Flex, Text } from "@storyofams/react-ui";
import Image from "next/image";
import { showToast } from "~lib";
import { CustomCheckbox } from "~components/common/CustomCheckbox";

export const CrowdFudningItem = ({
  product,
  selectedProduct,
  setSelectedProducts,
}) => {
  return (
    <Flex
      mb={1}
      width={"100%"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Flex alignItems={"center"}>
        <Box
          cursor={"pointer"}
          onClick={() =>
            showToast(
              "Dit product kun je niet verwijderen uit de bundel",
              "error"
            )
          }
        >
          <CustomCheckbox
            mr={"10px"}
            border={"1px solid #E2DFDF"}
            checked={selectedProduct?.checked}
            disabled
            borderRadius={"3px"}
            width={["16px", "20px"]}
            height={["16px", "20px"]}
          />
        </Box>

        <Box
          mr={"10px"}
          borderRadius={"6px"}
          backgroundColor={"white"}
          width={["32px", "51px"]}
          overflow={"hidden"}
          height={["32px", "51px"]}
          position={"relative"}
          flexShrink={0}
        >
          <Image src={product.images.edges[0].node.url} layout="fill"></Image>
        </Box>
        <Text
          fontSize={["12px", "16px"]}
          lineHeight={["16.8px", "22.4px"]}
          fontWeight={500}
        >
          {product.title}
        </Text>
      </Flex>
      <Flex alignItems={"center"} ml="10px">
        <Flex
          width={["64px", "90px"]}
          height={"42px"}
          px={[1, "12.5px"]}
          alignItems="center"
          justifyContent={"space-between"}
          borderWidth="1px"
          backgroundColor={"white"}
          borderStyle="solid"
          borderColor="#E2DFDF"
          borderRadius="md"
        >
          <Button
            // disabled={selectedProduct?.quantity <= 1}
            onClick={(e) => {
              if (selectedProduct?.quantity <= 1) {
              showToast("Dit product kun je niet verwijderen uit de bundel", "error");
              return;
            }
              setSelectedProducts((selectedProducts) =>
                selectedProducts.map((item) => {
                  if (selectedProduct.id === item.id)
                    return { ...item, quantity: selectedProduct.quantity - 1 };
                  return item;
                })
              );
            }}
            style={{
            cursor: selectedProduct?.quantity <= 1 ? 'not-allowed' : 'pointer',
            opacity: selectedProduct?.quantity <= 1 ? 0.5 : 1
          }}
          >
            -
          </Button>

          <Box
            width="20px"
            as="input"
            textAlign="center"
            type="number"
            fontFamily="Barlow"
            fontSize="16px"
            fontWeight={500}
            border="none"
            min="1"
            disabled={product.id === "gid://shopify/Product/14798883258743"}
            value={selectedProduct?.quantity}
            onChange={(event) => {
              if (product.id === "gid://shopify/Product/14798883258743") {
                return; // Do nothing for this product
              }
              const value = parseInt(event.target.value) || 1; // Convert to number, default to 1 if invalid
              const validValue = Math.max(1, value);
              if (event.target.value === "0") {
                  showToast("Dit product kun je niet verwijderen uit de bundel", "error");
              }
              setSelectedProducts((selectedProducts) =>
                selectedProducts.map((item) => {
                  if (selectedProduct.id === item.id)
                    return { ...item, quantity: validValue };
                  return item;
                })
              );
            }}
          />

          <Button    
          disabled = {product.id === "gid://shopify/Product/14798883258743"}
            onClick={(e) => {
              
              setSelectedProducts((selectedProducts) =>
                selectedProducts.map((item) => {
                  if (selectedProduct.id === item.id)
                    return { ...item, quantity: selectedProduct.quantity + 1 };
                  return item;
                })
              );
            }}
          >
            +
          </Button>
        </Flex>
        <Box
          fontWeight={400}
          lineHeight={"22.4px"}
          fontSize={"16px"}
          textAlign={"end"}
          width={["50px", "50px"]}
          ml={["6px", "10px"]}
        >
          {product.variants.edges[0].node?.compareAtPriceV2?.amount && (
            <Text opacity={0.5} textDecoration={"line-through"}>
              €
              {Number(
                product.variants.edges[0].node?.compareAtPriceV2?.amount
              ).toFixed(2)}
            </Text>
          )}
          {product.variants.edges[0].node?.priceV2?.amount && (
            <Text>
              €
              {Number(product.variants.edges[0].node?.priceV2?.amount).toFixed(
                2
              )}
            </Text>
          )}
        </Box>
      </Flex>
    </Flex>
  );
};
